module.exports = __webpack_public_path__ + "static/media/topshape.40e08ec9.png";